import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { ddRumScript } from '../../utils/scripts';
import ErrorCatchProvider from '../../components/ErrorCatchProvider';
import { SellersComponent } from './components/SellersComponent';
import { getContentView } from './utils/build-view';
import { EXTERNAL_COMPONENT_PROVIDERS } from '../../utils/constants';
import { handleScroll } from '../../utils/scroll';

const SellersView = (props) => {
  const {
    experiments = {},
    isWebView = false,
    isMobile,
    landingConfig: {
      groupId,
      variantId,
      landingVersionId: versionId,
      variantConfigurationId,
      variantName,
      tracking: { melidata },
      custom: { ddrumConfig = null },
    },
    coreValues: {
      userId,
      coupon = null,
      channel = null,
      subChannel = null,
      siteId = null,
      userAgent = null,
    },
    clientLogsEnabled = false,
  } = props;

  useEffect(() => {
    if (document.readyState === 'complete') {
      handleScroll();
    } else {
      window.addEventListener('load', handleScroll);
    }

    // Datadog RUM script for browser, options in global settings > custom > ddrum
    if (ddrumConfig) {
      ddRumScript(ddrumConfig, {
        userId,
        coupon,
        channel,
        subChannel,
        groupId,
        variantId,
        versionId,
        variantConfigurationId,
        variantName,
        experiments,
        isWebView,
        isMobile,
        tracking: melidata,
        siteId,
        userAgent,
      });
    }

    return () => window.removeEventListener('load', handleScroll);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const content = getContentView(
    props,
    EXTERNAL_COMPONENT_PROVIDERS.sellers.id,
    SellersComponent,
  );

  return clientLogsEnabled ? (
    <ErrorCatchProvider {...props}>{content}</ErrorCatchProvider>
  ) : (
    content
  );
};

SellersView.propTypes = {
  experiments: PropTypes.shape({}),
  imagesPrefix: PropTypes.string,
  isMobile: PropTypes.bool.isRequired,
  isWebView: PropTypes.bool,
  landingConfig: PropTypes.shape({
    groupId: PropTypes.string,
    variantId: PropTypes.string,
    landingVersionId: PropTypes.string,
    variantConfigurationId: PropTypes.string,
    variantName: PropTypes.string,
    head: PropTypes.shape({ title: PropTypes.string }),
    productName: PropTypes.string,
    space: PropTypes.string,
    tracking: PropTypes.shape({
      gtm: PropTypes.shape({}),
      melidata: PropTypes.shape({
        calmTrack: PropTypes.shape({}),
        skipCalmTrack: PropTypes.bool,
        enableShowTrack: PropTypes.bool,
      }),
      hotjar: PropTypes.shape({
        id: PropTypes.number,
      }),
    }),
    custom: PropTypes.shape({
      ddrumConfig: PropTypes.shape({}),
    }),
  }),
  locale: PropTypes.string,
  device: PropTypes.shape({
    type: PropTypes.string,
    webView: PropTypes.bool,
  }),
  mainStyles: PropTypes.shape({}),
  sections: PropTypes.arrayOf(PropTypes.shape({})),
  scope: PropTypes.string,
  initCallback: PropTypes.func,
  csrfToken: PropTypes.string,
  baseApiPath: PropTypes.shape({}),
  landingStatus: PropTypes.shape({}),
  isPreview: PropTypes.bool,
  recaptchaSiteKey: PropTypes.string,
  coreValues: PropTypes.shape({
    userId: PropTypes.string,
    coupon: PropTypes.string,
    channel: PropTypes.string,
    subChannel: PropTypes.string,
    siteId: PropTypes.string,
    userAgent: PropTypes.string,
  }),
  isRebrand: PropTypes.bool,
  theme: PropTypes.string,
  translationsRebrand: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    confirmButton: PropTypes.string,
  }),
  hiddenModal: PropTypes.bool,
  clientLogsEnabled: PropTypes.bool,
};

export default SellersView;
